import { createApp } from 'vue';
import { createPinia, defineStore } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useLimitsStore } from './modules/limits-store';
import { useUserRegisterPaymentModalStore } from './modules/user-register-payment-modal-store';
import { useQuestionnaireModalStore } from './modules/questionnaire-modal-store';
import { useUploaderStore } from './modules/uploader-store';
import { useUserStore } from './modules/user-store';
import { useJobStore } from './modules/job-store';

let piniaInstance = null; // Singleton for Pinia instance

export function getPiniaInstance() {
    if (!piniaInstance) {
        piniaInstance = createPinia(); // Create and store the Pinia instance if it doesn't exist
    }
    return piniaInstance;
}

export function getPiniaPersistedstateInstance() {
    if (!piniaInstance) {
        piniaInstance = createPinia();
    }
    return piniaInstance.use(piniaPluginPersistedstate); // Use the persisted state plugin
}

export function initPiniaPageStore() {
    if (!piniaInstance) {
        const app = createApp({}); // Create a new Vue 3 app instance
        app.use(getPiniaInstance()); // Use the singleton Pinia instance
    }
}

export const usePageStore = defineStore('pageStore', () => {
    return {
        user: useUserStore(),
        job: useJobStore(),
        limits: useLimitsStore(),
        questionnaireModal: useQuestionnaireModalStore(),
        userPaymentModal: useUserRegisterPaymentModalStore(),
        uploader: useUploaderStore(),
    };
});

// Vue 3 Mixin alternative: Using Composition API
export const pageStoreMixin = {
    data() {
        return {
            store: usePageStore()
        };
    },
};